// extracted by mini-css-extract-plugin
module.exports = {"root":"MainMenu_root__1OAu4"};